import { useMediaQuery } from '@mui/material';
import classNames from 'classnames';
import cn from 'classnames';
import { FC, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

import { setLocalStorage } from '../../common/util/localStorage';
import { BottomNavigation } from '../../components/Mobile/BottomNavigation';
import { useLayout } from '../../hooks/useLayout';
import { useSearch } from '../../hooks/useSearch';
import { Footer } from '../Footer';
import { Header } from '../Header';

import styles from './Layout.module.sass';

interface ILayoutProps {
  children: ReactNode;
}

export const Layout: FC<ILayoutProps> = ({ children }) => {
  const { page } = useLayout();
  const { pathname } = useLocation();
  const { visibleHistory } = useSearch();
  const tableScreen = useMediaQuery('(max-width:900px)');
  const mobileScreen = useMediaQuery('(max-width:900px)');
  const getSearchHistory =
    setLocalStorage.getFromLocalStorage('SEARCH_ADD_HISTORY');
  return (
    <div
      className={classNames(styles.layout, {
        [styles.searchItems]: visibleHistory && getSearchHistory.length !== 0,
      })}
    >
      <Header />
      <main
        className={cn(styles.content, {
          [styles.checkout]: pathname.slice(1) === 'basket',
          [styles.orderInfo]: pathname.slice(1) === 'order-info',
        })}
      >
        {children}
      </main>
      {tableScreen && <BottomNavigation />}
      <Footer />
    </div>
  );
};
